const FAQ = () => {
  return <div id="data-for-ssg">FAQ</div>;
};

export default FAQ;
